/**
 * Gives each upload a turn and lets only the latest turn report back.
 *
 * Starting a new turn ends every earlier one. Whatever an ended turn finishes later, a success or an error, is dropped.
 */
export class UploadTurns {
  private current = 0;

  /** Ends every earlier turn and returns the new one. */
  public next(): number {
    this.current += 1;
    return this.current;
  }

  /** Whether `turn` is still the latest. */
  public isCurrent(turn: number): boolean {
    return turn === this.current;
  }

  /** Returns `report` wrapped to do nothing once `turn` has ended. */
  public guard<Args extends unknown[]>(turn: number, report: (...args: Args) => void): (...args: Args) => void {
    return (...args) => {
      if (this.isCurrent(turn)) report(...args);
    };
  }
}
